import {inject} from '@angular/core';
import {ResolveFn} from '@angular/router';
import {ApiDayTripDetail, DayTripService} from '../../../../apiclients/playble';
import {catchError, of} from 'rxjs';

/**
 * Prefetch day trip detail during navigation so SSR can emit correct
 * Open Graph tags before the HTML is serialised for social crawlers.
 */
export const dayTripDetailResolver: ResolveFn<ApiDayTripDetail | null> = route => {
  const id = Number(route.paramMap.get('id'));
  if (!Number.isFinite(id) || id <= 0) {
    return of(null);
  }

  return inject(DayTripService).apiDayTripIdGet(id).pipe(
    catchError(() => of(null))
  );
};
